import React from 'react';

const ReportTabsBar = ({ tabs, activeTab, onChange }) => (
  <div className="flex border-b border-gray-200 mb-4 sm:mb-6 overflow-x-auto">
    {tabs.map((tab) => {
      const Icon = tab.icon;
      const active = activeTab === tab.id;

      return (
        <button
          key={tab.id}
          type="button"
          onClick={() => onChange(tab.id)}
          aria-label={tab.label}
          className={`px-4 py-2.5 font-semibold text-sm transition-all duration-200 border-b-2 whitespace-nowrap ${active ? 'border-[#FF5733] text-[#FF5733]' : 'border-transparent text-gray-600 hover:text-[#2a2e30]'}`}
          title={tab.description || tab.label}
        >
          <span className="md:hidden inline-block">
            <Icon className="w-5 h-5" />
          </span>
          <span className="hidden md:inline">{tab.label}</span>
        </button>
      );
    })}
  </div>
);

export default ReportTabsBar;
